/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 *
 * Networth
 *
 */
import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { messages } from './messages';
import { LockNetworth, Track } from 'constants/constants';
import { NetworthBox1 } from 'app/components/NetworthBox1';

import { media } from 'styles/media';

import { useNetworth } from 'app/Provider/NetworthProvider';
import { TrackAssets } from 'app/components/TrackAssets';
import { FinancialData } from 'app/pages/Networth/slice/types';
import { useDispatch, useSelector } from 'react-redux';
import { useGetNetworthSlice } from 'app/pages/Networth/slice';
import { selectGetNetworth } from 'app/pages/Networth/slice/selectors';
import { Loader } from 'app/components/Loader';
import { useGoalSlice } from 'app/components/GoalPlannerCard/slice';
import { selectGoal } from 'app/components/GoalPlannerCard/slice/selectors';
import close from './CloseRed.svg';
import { useNavigate } from 'react-router-dom';
import { NetworthGrowthGraph } from 'app/components/NetworthGrowthGraph';
import { Store } from 'storage';
import { AddPartnerform } from 'app/components/AddPartnerform';
import { CongratsComponent } from 'app/components/CongratsComponent';
import { useGoalPlanner } from 'app/Provider/GoalPlannerProvider';
interface Props {}

const store = new Store();
const addAssetsPopupKey = 'add-assets';

type OptionType = {
  value: string;
  label: string;
};

export const Networth = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [goalData, setGoalData] = useState<any>({
    name: '',
    id: '',
  });
  const [showModal, setShowModal] = useState(false);
  const { toggleModal } = useGoalPlanner();
  const [isClosed, handleclose] = React.useState(false);
  const { actions } = useGetNetworthSlice();
  const { isGroup } = useNetworth();
  const { actions: goalaction } = useGoalSlice();
  const { getGoalDataSuccessResponse, createGoalSuccessResponse } =
    useSelector(selectGoal);
  const { getNetworthSuccessResponse, isLoading } =
    useSelector(selectGetNetworth);
  const { login, data, setdata, setAssets, setLiabilities, setNetworth } =
    useNetworth();
  const navigate = useNavigate();
  const id = store.get('goal_id');

  const formatAmount = amount => {
    if (amount == null || amount === '' || isNaN(Number(amount))) {
      return '0.00';
    }

    const parsedAmount = parseFloat(amount).toFixed(2);

    let [integerPart, fractionalPart] = parsedAmount.split('.');

    if (integerPart.length > 3) {
      let lastThree = integerPart.slice(-3);
      let otherNumbers = integerPart.slice(0, integerPart.length - 3);
      otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      integerPart = `${otherNumbers},${lastThree}`;
    }

    return `${integerPart}.${fractionalPart}`;
  };

  useEffect(() => {
    dispatch(actions.getNetworth({ isGroup }));
  }, [dispatch, actions, isGroup]);

  useEffect(() => {
    if (getNetworthSuccessResponse) {
      const formattedResponse =
        getNetworthSuccessResponse as unknown as FinancialData;
      setdata(formattedResponse);
      setNetworth(formatAmount(String(formattedResponse.total_networth)));
      setAssets(formatAmount(String(formattedResponse.assets_worth)));
      setLiabilities(formatAmount(String(formattedResponse.liabilities_worth)));
    }
  }, [
    getNetworthSuccessResponse,
    setAssets,
    setLiabilities,
    setNetworth,
    setdata,
  ]);

  useEffect(() => {
    if (id) {
      dispatch(goalaction.getGoalData(id));
      store.remove('goal_id');
    }
  }, [id, dispatch, goalaction]);

  useEffect(() => {
    if (getGoalDataSuccessResponse) {
      const Payload = {
        name: getGoalDataSuccessResponse.name,
        description: getGoalDataSuccessResponse.description,
        start_date: getGoalDataSuccessResponse.start_date,
        opening_amount: getGoalDataSuccessResponse.opening_amount,
        target_amount: getGoalDataSuccessResponse.target_amount,
        target_date: getGoalDataSuccessResponse.target_date,
        purpose: getGoalDataSuccessResponse.purpose,
        type: getGoalDataSuccessResponse.type,
        contribution_frequency:
          getGoalDataSuccessResponse.contribution_frequency,
        metadata: getGoalDataSuccessResponse.metadata,
      };
      dispatch(goalaction.createGoal(Payload));
    }
  }, [getGoalDataSuccessResponse, dispatch, goalaction]);

  useEffect(() => {
    if (createGoalSuccessResponse) {
      setGoalData({
        name: createGoalSuccessResponse.name,
        id: createGoalSuccessResponse.id,
      });
      setShowModal(true);
      toggleModal();
      dispatch(goalaction.responsenull());
    }
  }, [createGoalSuccessResponse, dispatch, goalaction, toggleModal]);

  const hideAssetsFormKey = 'hide-assets-form';
  return isLoading ? (
    <div>
      <h6 className="d-flex justify-content-center mb-3 mt-3">
        Fetching networth...
      </h6>
      <Loader />
    </div>
  ) : (
    <Container>
      <CardWrapper>
        <Card>
          <Wrapper className="w-100 d-flex  flex-column p-xl-3  p-md-4 p-0 gap-4  py-4 w-100 ">
            <NetworthContainer className="d-flex  gap-4">
              <NetworthBox1 />

              <GraphOuterContainer className=" col position-relative  ">
                <GraphContainer
                  className={` border d-flex flex-column    ${
                    !login ? 'blurred-content' : ''
                  }`}
                >
                  <div className="d-flex d-md-none border-bottom  justify-content-center  gap-2 my-1   ">
                    <GraphText className=" px-1">
                      1{t(messages.day())}
                    </GraphText>
                    <GraphText className="border-start px-2">
                      1{t(messages.week())}
                    </GraphText>
                    <GraphText className="border-start px-2">
                      1{t(messages.month())}
                    </GraphText>
                    <GraphSelectText className="border-start px-2">
                      3{t(messages.month())}
                    </GraphSelectText>
                    <GraphText className="border-start px-2">
                      6{t(messages.month())}
                    </GraphText>
                    <GraphText className="border-start px-2">
                      1{t(messages.year())}
                    </GraphText>
                    <GraphText className="border-start px-2">
                      3{t(messages.year())}
                    </GraphText>
                    <GraphText className="border-start px-2">
                      5{t(messages.year())}
                    </GraphText>
                  </div>

                  <Graph className="w-100">
                    <NetworthGrowthGraph networth={data.total_networth} />
                  </Graph>
                </GraphContainer>
                {!data.total_networth && (
                  <Overlay className=" position-absolute top-0 w-100  d-flex flex-column align-items-center gap-3 justify-content-center">
                    <img src={LockNetworth} alt="" />
                    <OverlayText className="text-center  ">
                      {t(messages.error2())}
                    </OverlayText>
                  </Overlay>
                )}
              </GraphOuterContainer>
            </NetworthContainer>
            <AddPartnerform />
            <AddAssetBox
              className="p-3"
              isvisible={isClosed || store.get(hideAssetsFormKey)}
            >
              <div className=" d-flex justify-content-between align-items-center">
                <Textmd>Securely add assets and liabilities</Textmd>
                <img
                  src={close}
                  alt="close btn"
                  className="cursor-pointer"
                  onClick={() => {
                    store.set(hideAssetsFormKey, 'true');
                    handleclose(!isClosed);
                  }}
                />
              </div>
              <div className=" d-flex gap-3 mt-2">
                <div className="w-75">
                  <InfoText>
                    Add assets and liabilities to accurately track your net
                    worth and goal success probability rate. It is essential
                    part so that you can make complete use of this platform. It
                    is 100% secure and pose no threat to your data.
                  </InfoText>
                </div>
                <div className="w-25">
                  <Button
                    onClick={() => {
                      navigate('/addasset');
                    }}
                  >
                    Add assets and liabilities
                  </Button>
                </div>
              </div>
            </AddAssetBox>

            <TrackAssets />
          </Wrapper>
        </Card>
      </CardWrapper>
      {showModal && (
        <CongratsComponent boxText={goalData.name} id={goalData.id} />
      )}
    </Container>
  );
});
interface ViewProp {
  isvisible: boolean;
}

const Button = styled.button`
  background-color: #8276f4;
  color: #ffff;
  font-weight: 600;
  font-size: 12px;
  border: none;
  padding: 10px 30px;
  border-radius: 30px;
  height: 36px;
  cursor: pointer;

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

const InfoText = styled.span`
  font-weight: 400;
  font-size: 14px;
`;
const AddAssetBox = styled.div<ViewProp>`
  border: 1px solid #e4e6ec;
  border-radius: 20px;
  background-color: #ffff;
  width: 100%;
  height: 136px;
  display: ${props => (props.isvisible ? 'none' : 'block')};
`;
const Textmd = styled.span`
  font-weight: 600;
  font-size: 20px;
`;

const Input = styled.input`
  border: none;
  border-bottom: 1px solid;
  outline: none;
  font-size: 16px;
  font-weight: 200;
`;
const AddPartnerContainer = styled.div`
  height: 202px;
  border: 1px solid #e4e6ec;
  border-radius: 20px;
`;
const AddPartnerText = styled.div`
  font-size: 24px;
  font-weight: 400;
`;

const AddPartnerHeading = styled.h3`
  font-size: 16px;
  font-weight: 500;
`;
const NetworthContainer = styled.div`
  ${media.medium} {
    flex-direction: column;
  }
  ${media.small} {
    flex-direction: column;
  }
`;

const Graph = styled.div`
  height: 100%;
  ${media.medium} {
    height: 85%;
  }
`;
const OverlayText = styled.p`
  width: 50%;
  ${media.medium} {
    width: 80%;
  }
  ${media.small} {
    width: 90%;
  }
`;

const Wrapper = styled.div`
  background-color: #f5f6fa;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  position: relative;
  overflow: hidden;
`;
const Card = styled.div<{ right?: boolean }>`
  //////
  flex-grow: 1;
  overflow-y: auto;
  transition: max-height 0.3s ease-in-out;
  ::-webkit-scrollbar {
    width: 0px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent; /* Color of the thumb */
    border-radius: 15px; /* Rounded corners */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #e4dfff; /* Color of thumb when hovered */
  }

  ::-webkit-scrollbar-track {
    background-color: transparent; /* Background color of the track */
    border-radius: 15px; /* Rounded corners of the track */
  }

  ::-webkit-scrollbar-corner {
    background-color: #e4dfff; /* Corner of the scrollbar */
  }
`;
const CardWrapper = styled.div`
  width: 100%;
  height: 100%; // Set explicit height
  display: flex;
`;
const GraphOuterContainer = styled.div``;
const Overlay = styled.div`
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  height: 264px;
  pointer-events: auto; /* Allow interaction with the overlay */
`;

const GraphBorder = styled.div`
  border-bottom: 0px solid black;

  ${media.xlarge} {
    border-bottom: 1px solid #f3f1fe;
  }

  /* ${media.large} {
    border-bottom: 1px solid #f3f1fe;
  } */
  ${media.medium} {
    border-bottom: 1px solid #f3f1fe;
  }
  ${media.small} {
    border-bottom: 0px solid #f3f1fe;
  }
`;
const GraphContainer = styled.div`
  height: 264px;
  width: 30vw;
  border-radius: 20px;
  background-color: #ffffff;
  width: auto;
  ${media.medium} {
    width: 70vw;
  }
  ${media.small} {
    width: 350px;
    height: 272px;
  }
`;

const GraphText = styled.h3`
  font-size: 16px;
  font-weight: 300;
  color: #838eae;
  cursor: pointer;
  ${media.medium} {
    font-size: 14px;
  }
`;
const GraphSelectText = styled.h3`
  font-size: 16px;
  font-weight: 800;
  ${media.medium} {
    font-size: 14px;
  }
`;
